module.exports = __webpack_public_path__ + "img/buy.3fdd8752.png";